"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.smsTemplate = void 0;
var utils_1 = require("../../utils");
var smsCustomGroupsUrl = '/sms-templates/custom/groups';
exports.smsTemplate = function (axios) {
    return {
        // [Sms Template]
        getSmsTemplatesCustomGroups: function (getSmsTemplatesCustomGroups) {
            return axios.get(smsCustomGroupsUrl, getSmsTemplatesCustomGroups);
        },
        getSmsTemplatesCustomGroupsGroupNoTemplatesTemplateNo: function (getSmsTemplatesCustomGroupsGroupNoTemplatesTemplateNo) {
            var url = smsCustomGroupsUrl + "/{groupNo}/templates/{templateNo}";
            url = utils_1.paramPathchange(url, getSmsTemplatesCustomGroupsGroupNoTemplatesTemplateNo);
            return axios.get(url, getSmsTemplatesCustomGroupsGroupNoTemplatesTemplateNo);
        },
        postSmsTemplatesCustomGroups: function (postSmsTemplatesCustomGroups) {
            return axios.post(smsCustomGroupsUrl, postSmsTemplatesCustomGroups.data, postSmsTemplatesCustomGroups);
        },
        postSmsTemplatesCustomGroupsTemplates: function (postSmsTemplatesCustomGroupsTemplates) {
            var url = smsCustomGroupsUrl + "/{groupNo}/templates";
            url = utils_1.paramPathchange(url, postSmsTemplatesCustomGroupsTemplates);
            return axios.post(url, postSmsTemplatesCustomGroupsTemplates.data, postSmsTemplatesCustomGroupsTemplates);
        },
        getSmsTemplatesCustomGroupsTemplates: function (getSmsTemplatesCustomGroupsTemplates) {
            var url = smsCustomGroupsUrl + "/{groupNo}/templates/{templateNo }";
            url = utils_1.paramPathchange(url, getSmsTemplatesCustomGroupsTemplates);
            return axios.get(url, getSmsTemplatesCustomGroupsTemplates);
        },
        deleteSmsTemplatesCustomGroupsTemplates: function (deleteSmsTemplatesCustomGroupsTemplates) {
            var url = smsCustomGroupsUrl + "/{groupNo}/templates/{templateNo}";
            url = utils_1.paramPathchange(url, deleteSmsTemplatesCustomGroupsTemplates);
            return axios.delete(url, deleteSmsTemplatesCustomGroupsTemplates);
        },
        deleteSmsTemplatesCustomGroups: function (deleteSmsTemplatesCustomGroups) {
            var url = smsCustomGroupsUrl + "/{groupNo}";
            url = utils_1.paramPathchange(url, deleteSmsTemplatesCustomGroups);
            return axios.delete(url, deleteSmsTemplatesCustomGroups);
        },
        putSmsTemplatesCustomGroups: function (putSmsTemplatesCustomGroups) {
            var url = smsCustomGroupsUrl + "/{groupNo}";
            url = utils_1.paramPathchange(url, putSmsTemplatesCustomGroups);
            return axios.put(url, putSmsTemplatesCustomGroups.data, putSmsTemplatesCustomGroups);
        },
        putSmsTemplatesCustomGroupsOrder: function (putSmsTemplatesCustomGroupsOrder) {
            var url = smsCustomGroupsUrl + "/{groupNo}/order";
            url = utils_1.paramPathchange(url, putSmsTemplatesCustomGroupsOrder);
            return axios.put(url, putSmsTemplatesCustomGroupsOrder.data, putSmsTemplatesCustomGroupsOrder);
        },
        putSmsTemplatesCustomGroupsTemplates: function (putSmsTemplatesCustomGroupsTemplates) {
            var url = smsCustomGroupsUrl + "/{groupNo}/templates/{templateNo}";
            url = utils_1.paramPathchange(url, putSmsTemplatesCustomGroupsTemplates);
            return axios.put(url, putSmsTemplatesCustomGroupsTemplates.data, putSmsTemplatesCustomGroupsTemplates);
        },
        putSmsTemplatesCustomGroupsTemplatesOrder: function (putSmsTemplatesCustomGroupsTemplatesOrder) {
            var url = smsCustomGroupsUrl + "/{groupNo}/templates/{templateNo}/order";
            url = utils_1.paramPathchange(url, putSmsTemplatesCustomGroupsTemplatesOrder);
            return axios.put(url, putSmsTemplatesCustomGroupsTemplatesOrder.data, putSmsTemplatesCustomGroupsTemplatesOrder);
        },
        getSmsTemplatesAutoGroups: function (getSmsTemplatesAutoGroups) {
            return axios.get('/sms-templates/auto/groups', getSmsTemplatesAutoGroups);
        },
        putSmsTemplatesAutoTemplatesTemplateType: function (putSmsTemplatesAutoTemplatesTemplateType) {
            var url = '/sms-templates/auto/templates/{templateType}';
            url = utils_1.paramPathchange(url, putSmsTemplatesAutoTemplatesTemplateType);
            return axios.put(url, putSmsTemplatesAutoTemplatesTemplateType.data, putSmsTemplatesAutoTemplatesTemplateType);
        },
        getSmsTemplatesAutoTemplatesTemplateType: function (getSmsTemplatesAutoTemplatesTemplateTypeRequest) {
            var url = '/sms-templates/auto/templates/{templateType}';
            url = utils_1.paramPathchange(url, getSmsTemplatesAutoTemplatesTemplateTypeRequest);
            return axios.get(url, getSmsTemplatesAutoTemplatesTemplateTypeRequest);
        },
        putSmsTemplatesAutoNight: function (putSmsTemplatesAutoNightRequest) {
            return axios.put('/sms-templates/auto/night', putSmsTemplatesAutoNightRequest.data, putSmsTemplatesAutoNightRequest);
        }
    };
};
